// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3aA3s","content":"styles_content__20HA8","selectAll":"styles_selectAll__1iNYq"};